import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../service.service';

interface Employee {
  employee_id: string;
  employee_name: string;
}

@Component({
  selector: 'app-excluded-rfr-users-edit',
  templateUrl: './excluded-rfr-users-edit.component.html',
  styleUrls: ['./excluded-rfr-users-edit.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ExcludedRfrUsersEditComponent implements OnInit {

   employees: Employee[] = [];
  selectedEmployeeIds: string[] = [];   
  selectedEmployees: Employee[] = [];   
  isLoadingEmps = false;
  isSaving = false;

  loadError: string | null = null;
  successMessage: string | null = null;

  constructor(
    private router: Router,
    private apiService: ServiceService
  ) {}

  ngOnInit(): void {
    this.loadEmployees();
    this.loadExistingExclusions();
  }

  loadEmployees(): void {
    this.isLoadingEmps = true;
    this.apiService.ViewAllEmployeefilter('').subscribe({
      next: (res: any) => {
        this.isLoadingEmps = false;
        if (res && (res.success || res.sucess) && Array.isArray(res.data)) {
          this.employees = res.data;
        }
      },
      error: () => {
        this.isLoadingEmps = false;
        this.loadError = 'Failed to load employees.';
      }
    });
  }

  loadExistingExclusions(): void {
    this.apiService.getExcludedRfrEmployees().subscribe({
      next: (res: any) => {
        const list = res?.data?.employees || res?.data || [];
        if (Array.isArray(list)) {
          this.selectedEmployees = list.map((d: any) => ({
            employee_id: d.employee_id,
            employee_name: d.employee_name
          }));
          this.selectedEmployeeIds = this.selectedEmployees.map(e => e.employee_id);
        }
      },
      error: () => {
        this.loadError = 'Failed to load current exclusion list.';
      }
    });
  }

  onSelectionChange(ids: string[]): void {
    ids.forEach(id => {
      if (!this.selectedEmployees.some(e => e.employee_id === id)) {
        const emp = this.employees.find(e => e.employee_id === id);
        if (emp) this.selectedEmployees.push(emp);
      }
    });
    this.selectedEmployees = this.selectedEmployees.filter(e => ids.includes(e.employee_id));
  }

  removeEmployee(emp: Employee): void {
    this.selectedEmployees = this.selectedEmployees.filter(e => e.employee_id !== emp.employee_id);
    this.selectedEmployeeIds = this.selectedEmployeeIds.filter(id => id !== emp.employee_id);
  }
  clearAllEmployees(): void {
    this.selectedEmployees = [];
    this.selectedEmployeeIds = [];
  }

  onSave(): void {
    this.isSaving = true;
    this.loadError = null;
    this.successMessage = null;

    const body = {
      employees: this.selectedEmployees.map(e => ({
        employee_id: e.employee_id,
        employee_name: e.employee_name
      }))
    };

    this.apiService.updateExcludedRfrEmployees(body).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        if (res && (res.success || res.sucess)) {
          this.successMessage = 'Updated successfully!';
          setTimeout(() => {
            this.router.navigate(['/admin/excluded-rfr-users-listing']);
          }, 1500);
        } else {
          this.loadError = 'Update failed. Please try again.';
        }
      },
      error: () => {
        this.isSaving = false;
        this.loadError = 'Failed to update. Please try again.';
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/admin/excluded-rfr-users-listing']);
  }
}